import React from 'react';
import {Outlet} from 'react-router-dom';

const IpRestriction: React.FC = () => {
  return <Outlet />;
};

export default IpRestriction;
